import { format } from "date-fns";
import koLocale from "date-fns/locale/ko";
import dayjs from "dayjs";
// TODO moment --> dayjs로 변경
import moment from "moment";
import i18n from "src/i18n";

export const getDateformat = (date: string) => {
  let dateFormat = new Date(date);
  if (date && String(date).length === 10) {
    dateFormat = new Date(parseInt(date) * 1000);
  } else {
    dateFormat = new Date(date);
  }
  // return format(dateFormat, config.date.format, { locale: koLocale })
  return format(dateFormat, {} as string, { locale: koLocale });
};

// UTCtimeConversion : 서버에 저장된 DB의 Time을 클라이언트의 Time으로 바꿈
// 서버(UTC time) -> 클라이언트(클라이언트 Timezone으로 보정된 시간)
export const UTCtimeConversion = (dateString: string) => {
  // 클라이언트의 Timezone 구하기
  const currentDate = new Date();
  const timezoneOffset = currentDate.getTimezoneOffset();
  const timeConversion = -(timezoneOffset / 60);

  // 서버 : UTC 시간
  // 클라이언트 : UTC 시간에서 보정된 값(dateObject)
  let dateObject: any = new Date(dateString.replace(/\s/, "T"));
  dateObject.setHours(dateObject.getHours() + timeConversion);

  // Date Formatting
  dateObject = moment(dateObject).format("YYYY-MM-DD HH:mm");

  return moment(dateObject).format("YYYY-MM-DD HH:mm");
};

export const dateFormat = (date: string, format?: string) => {
  return moment(date).local().format("YYYY-MM-DD HH:mm");
};

export const dateFormatUtc = (date: string) => {
  return moment.utc(date).local().format("YYYY-MM-DD HH:mm");
};

export const dateFormatUtcToYMD = (date: string | number) => {
  return moment.utc(date).local().format("YYYY-MM-DD");
};

// 구독 종료일 - 1일 더해서 표시
export const serviceEndTimeFormat = (date: string | number) => {
  return dayjs(date).add(1, "day").format("YYYY-MM-DD");
};

export const dateFormatUtcToYMD1 = (date: string) => {
  if (i18n.language === "ko") {
    return moment.utc(date).local().format("YYYY-MM-DD");
  } else {
    return moment.utc(date).local().format("MMM DD. YYYY.");
  }
};

export const dateFormatUtcToISO = (date: string) => {
  return moment.utc(date).local().format("YYYY-MM-DDTHH:mmZ");
};
